import { object, string } from 'yup';

export default object().shape({
  clienteTelefone: string().min(15, 'Mínimo 11 caracteres'),
  clienteEmail: string()
    .email('Digite um e-mail válido')
    .required('Campo obrigatório'),
});
